import React from 'react'
import moment from 'moment'
import {Typography} from '@mui/material'
import {makeStyles} from '@mui/styles'
import PropTypes from 'prop-types'
import {bodyText, H4HeaderBlack, subBodyText, totalText} from '../../../assets/styles/typography'
import {spaceExtraLarge, spaceSmall} from '../../../assets/styles/spacing'
import {rxrGreenColor} from '../../../assets/styles/color'

const useStyles = makeStyles(theme => ({
  rowContainer: {
    display: 'flex',
    justifyContent: 'space-between',
  },
  totalContainer: {
    display: 'flex',
    justifyContent: 'space-between',
    paddingTop: spaceSmall,
    borderTop: '1px solid black',
  },
  totalText: {
    ...totalText,
  },
  H4HeaderBlack: {
    ...H4HeaderBlack,
  },
  bodyText: {...bodyText},
  paymentAmount: {
    ...bodyText,
    color: rxrGreenColor,
  },
  subBodyText: {...subBodyText},
}))

export default function PaymentsTable(props) {
  const classes = useStyles()

  return (
    <div>
      <Typography className={classes.H4HeaderBlack}>Payments</Typography>
      {props.payments && props.payments.length > 0 ? (
        <React.Fragment>
          {props.payments.map(payment => {
            return (
              <div className={classes.payment}>
                <div className={classes.rowContainer}>
                  <Typography className={classes.bodyText}>{payment.paymentMethod.nickName}</Typography>
                  <Typography className={classes.paymentAmount}>{`$${payment.totalAmount.toFixed(2)}`}</Typography>
                </div>
                <div className={classes.rowContainer}>
                  <Typography className={classes.subBodyText}>{`${moment(payment.timestamp).format('MM/DD/YYYY')}, ${
                    payment.paymentMethod.type
                  }`}</Typography>
                  <Typography className={classes.subBodyText}>
                    {`${payment.status.charAt(0) + payment.status.slice(1).toLowerCase()}`} {payment.failureReason || ''}
                  </Typography>
                </div>
              </div>
            )
          })}
          <div className={classes.totalContainer}>
            <Typography className={classes.totalText}>Total payments</Typography>
            <Typography className={classes.totalText} style={{color: rxrGreenColor}}>
              $
              {`${props.payments
                .reduce((accum, element) => {
                  return accum + element.totalAmount
                }, 0)
                .toFixed(2)}`}
            </Typography>
          </div>
        </React.Fragment>
      ) : (
        <Typography className={classes.bodyText}>Resident has not made any payments</Typography>
      )}
    </div>
  )
}

PaymentsTable.propTypes = {
  payments: PropTypes.array,
}
